import React, { useState, useEffect } from "react";
import GradientButton from "../../../../../components/button/Button";
import PlainButton from "../../../../../components/button/PlainButton";
import axiosInstance from "../../../../../axiosInstance";

interface VendorCategory {
  id: string;
  name: string;
}

interface FilterVendorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (filters: {
    category: string;
    vendorName: string;
    location: string;
    vendorId: string;
  }) => void;
}

const FilterVendorModal: React.FC<FilterVendorModalProps> = ({
  isOpen,
  onClose,
  onFilter,
}) => {
  const [filters, setFilters] = useState({
    category: "",
    vendorName: "",
    location: "",
    vendorId: "",
  });

  const [categories, setCategories] = useState<VendorCategory[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  useEffect(() => {
    const getCategories = async () => {
      setLoadingCategories(true);
      try {
        const res = await axiosInstance.get("/segments");
        if (res?.data) {
          setCategories(res.data?.data || []);
        }
        setLoadingCategories(false);
      } catch (error) {
        setLoadingCategories(false);
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFilter = () => {
    onFilter(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header">
          <h2 className="orders-modal__title">Filter</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="orders-modal__form">
          <div className="orders-modal__form-group">
            <label htmlFor="category">Product category</label>
            <select
              id="category"
              name="category"
              value={filters.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {loadingCategories ? (
                <option disabled>Loading categories...</option>
              ) : (
                categories.map((category) => (
                  <option key={category.id} value={category.name}>
                    {category.name}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="vendorName">Vendor name</label>
            <input
              type="text"
              id="vendorName"
              name="vendorName"
              placeholder="Enter vendor name"
              value={filters.vendorName}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="location">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              placeholder="Enter location"
              value={filters.location}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="vendorId">Vendor ID</label>
            <input
              type="text"
              id="vendorId"
              name="vendorId"
              placeholder="Enter vendor ID"
              value={filters.vendorId}
              onChange={handleChange}
            />
          </div>
        </form>
        <div className="orders-modal__actions">
          <div className="orders-modal__clear">
            <PlainButton
              onClick={() =>
                setFilters({
                  category: "",
                  vendorName: "",
                  location: "",
                  vendorId: "",
                })
              }
              text="Clear Filter"
            />
          </div>
          <div className="orders-modal__apply">
            <GradientButton onClick={handleFilter} text="Filter" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterVendorModal;
